<template>
  <v-card>
    <v-card-title>
      {{ $t('reports.new.createTitle') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('reports.new.description') }}
    </v-card-subtitle>
    <v-card-text>
      <div class="mb-2" v-html="$t('reports.new.date', { date })" />
      <v-text-field
        :label="$t('common.name')"
        v-model="name"
        dense
        outlined
      />
    </v-card-text>
    <v-card-actions>
      <v-row class="mb-2 mx-2">
        <v-spacer />
        <v-btn
          rounded
          dense
          outlined
          small
          color="primary"
          @click="cancel"
          class="mr-2"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <SubmitButton small @click="submit" :label="$t('reports.new.create')" />
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'ReportForm',
  props: {},
  data () {
    return {
      name: this.$t('reports.new.defaultTitle', { date: dayjs().format('MMMM YYYY') }),
      date: dayjs().format('YYYY-MM-DD')
    }
  },
  methods: {
    cancel () {
      this.$eventBus.$emit('CLOSE_MODAL')
    },
    submit () {
      this.$emit('generate', { date: this.date, name: this.name })
      this.name = this.$t('reports.new.defaultTitle', { date: dayjs().format('MMMM YYYY') })
      this.date = dayjs().format('YYYY-MM-DD')
    }
  }
}
</script>
